import { Platform, StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';

const styles = StyleSheet.create({
    root: {
        flex: 1,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        justifyContent: 'center',
        paddingLeft: Platform.select({
            web: 0,
            default: 6,
        }),
        borderRadius: 2,
    },
    webStickyText: {
        // @ts-ignore
        position: 'sticky',
        alignSelf: 'flex-start',
        left: 6,
    },
});

export default styles;
